module.exports = __webpack_public_path__ + "img/avatar.ae01c5c9.jpg";